import { render, staticRenderFns } from "./LoginLink.vue?vue&type=template&id=23c51411&functional=true&"
import script from "./LoginLink.vue?vue&type=script&lang=js&"
export * from "./LoginLink.vue?vue&type=script&lang=js&"
import style0 from "./LoginLink.vue?vue&type=style&index=0&id=23c51411&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports